import { render, staticRenderFns } from "./TreatmentClosedCard.vue?vue&type=template&id=04362099&"
import script from "./TreatmentClosedCard.vue?vue&type=script&lang=js&"
export * from "./TreatmentClosedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports